import api from '~/services/api';

export const geradorDePLU = async (codTela: number): Promise<string> => {
  const storageKey = `USER_PREFERENCE_PLU_CADASTRO_RAPIDO_${codTela}`;

  const value = localStorage.getItem(storageKey);
  const type = value ? parseInt(value, 10) : 0;

  const res = await api.get(`/produto/genplu/${type}`);
  const { data, success } = res.data;

  if (success) {
    const { plu } = data;
    return plu;
  }

  return '';
};
